import { useCallback, useMemo, useState } from 'react'

const isValid = (formValues) => formValues?.groupName?.trim()?.length && formValues?.selectedTemplatesIds?.length

const getFormInitialState = (selectedTemplateGroup) => {
  if (!selectedTemplateGroup) {
    return {
      groupName: '',
      groupDescription: '',
      selectedTemplatesIds: [],
    }
  }

  return {
    groupName: selectedTemplateGroup?.name || '',
    groupDescription: selectedTemplateGroup?.description || '',
    selectedTemplatesIds: (selectedTemplateGroup?.templates || []).map((item) => item.id),
  }
}

const useGroupForm = ({ selectedTemplateGroup, policyTemplates }) => {
  const [formValues, setFormValues] = useState(getFormInitialState(selectedTemplateGroup))
  const [isFormDirty, setIsFormDirty] = useState(false)

  const updateForm = useCallback((value, field) => {
    setFormValues((prevForm) => ({ ...prevForm, [field]: value }))
    setIsFormDirty(true)
  }, [])

  const formOptions = useMemo(
    () => ({
      selectedTemplatesIds: policyTemplates?.map((item) => ({ label: item.template_name, value: item.id })),
    }),
    [policyTemplates],
  )

  const toApiPayload = useCallback(
    () => ({
      title: formValues?.groupName?.trim(),
      description: formValues?.groupDescription?.trim(),
      templates: formValues?.selectedTemplatesIds,
    }),
    [formValues],
  )

  const policyTemplatesMap = useMemo(() => {
    const result = {}
    policyTemplates.forEach((item) => {
      result[item.id] = item
    })
    return result
  }, [policyTemplates])

  const selectedTemplates = useMemo(
    () => formValues.selectedTemplatesIds.map((id) => policyTemplatesMap[id]),
    [policyTemplatesMap, formValues.selectedTemplatesIds],
  )

  return {
    formValues,
    updateForm,
    formOptions,
    toApiPayload,
    isFormValid: isValid(formValues),
    selectedTemplates,
    isFormDirty,
  }
}

export default useGroupForm
